import { EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth'
import { useCallback, useState } from 'react'
import { parseError } from '~src/models/apis/util'
import { useRootSelector } from '~src/stores'

type ReauthMutateInput = {
  password: string
}

export function useReauth () {
  const user = useRootSelector(state => state.auth.user)
  const [isValidating, setIsValidating] = useState(false)
  const [result, setResult] = useState(false)
  const [error, setError] = useState<any>()

  const mutate = useCallback(async (input: ReauthMutateInput) => {
    setResult(false)
    setError(undefined)

    // ユーザー認証必須
    if (user == null) {
      const err: Error & { code?: string } = new Error('Unauthenticated')
      err.code = 'unauthenticated-access'
      setError(err)
      throw err
    }

    // 開始
    setIsValidating(true)

    // firebase reauthenticate with email & password
    try {
      const cred = EmailAuthProvider.credential(
        user.email ?? '',
        input.password
      )
      await reauthenticateWithCredential(user, cred)
      setResult(true)
    } catch (err) {
      setError(err)
      setIsValidating(false)
      throw err
    }

    // 終了
    setIsValidating(false)
    return true
  }, [user])

  const reset = useCallback(() => {
    setResult(false)
    setError(undefined)
  }, [])

  return {
    isValidating,
    errorInfo: parseError(error),
    error,
    data: result,
    mutate,
    reset
  }
}
